import defaultOptions from "./default-options.js";
import defaultRoles from "./default-roles.js";
import defaultUser from "./default-user.js";

export default {
	defaultOptions,
	defaultRoles,
	defaultUser,
};
